<template>
    <app-dialog v-if="displayItems.length" :value="true" @input="dismissActiveItem" v-bind="{ ...$attrs }" max-width="65vw">
        <template v-slot:image>
            <!-- <component :is="activeItem.is" :layout="activeItem" max-height="62vh" :class="'mx-6'" :contain="true" /> -->

            <div v-if="activeItem.is === 'VideoBlockLayout'" class="mx-6" style="width: 40vw; height: 40vh">
                <video-block-layout overlay :url="activeItem.url" :listen-for-clicks="!!activeItem.banner_url" :auto-play="activeItem.auto_play" @click="onClick"></video-block-layout>
            </div>

            <v-img v-else-if="activeItem.is === 'BannerImageBlockLayout'" contain class="mx-6" max-height="62vh" :src="activeItem.file" @click="onClick" :style="activeItem.banner_url ? 'cursor: pointer' : 'cursor: default'">
                <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate class="dark-blue-color"></v-progress-circular>
                    </v-row>
                </template>
            </v-img>
        </template>
    </app-dialog>
</template>

<script>
export default {
    props: ['items'],

    watch: {
        items: {
            handler: function (items) {
                this.displayItems = [...items];
            },
            immediate: true,
        },

        displayItems() {
            if (this.displayItems?.length === 0 && !this.dismissed) {
                this.dismissed = true;
                this.$emit('finish');
            }
        },
    },

    data: () => ({
        displayItems: [],
        dismissed: false,
    }),

    computed: {
        activeItem() {
            return this.displayItems.at(0);
        },

        getDialogWidth() {
            return this.getResponsiveDialogWidth('65vw', '50vw');
        },

        getDialogHeight() {
            return this.getResponsiveDialogHeight('55vh', '75vh');
        },
    },

    methods: {
        dismissActiveItem() {
            const splicedBanner = this.displayItems.splice(0, 1);
            this.$emit('rendered', splicedBanner[0].banner_uuid);
        },

        onClick() {
            if (!this.activeItem.banner_url) {
                return;
            }

            this.$emit('click', this.activeItem);

            if (this.activeItem.in_new_tab) {
                window.open(this.activeItem.banner_url, '_blank');
            } else {
                window.location.href = this.activeItem.banner_url;
            }
        },
    },
};
</script>
